<template>
    <div class="personalCenter">
        <div class="personalInfoBox">
            <div class="top_center">
                <div class="personWrap">
                    <div class="uploadBox">
                        <p>{{name | formatName}}</p>
                    </div>
                    <div class="infoBox">
                        <h4>{{name}}</h4>
                        <p class="xf"><span>{{allScore}}</span><span>总学分</span></p>
                        <p class="totalTime">累计总时长 {{allSec | formatData}}</p>
                    </div>
                    <p class="mobile_xf"><span>{{allScore}}</span><span>总学分</span></p>
                </div>
                <div class="dataWrap">
                    <div class="sxsBox">
                        <h4>{{curSec | formatData}}</h4>
                        <p>本年度时长</p>
                        <span></span>
                    </div>
                    <div class="sxsBox">
                        <h4>{{curScore}}</h4>
                        <p>本年度学分</p>
                        <span></span>
                    </div>
                    <div class="sxsBox">
                        <h4>{{mark}}</h4>
                        <p>收藏</p>
                        <span></span>
                    </div>
                </div>
            </div>
            <div class="center_nav">
                <router-link v-for="(item,ind) in navList" :key="ind" :to="item.url">{{item.name}}<span class="line"></span></router-link>
            </div>
        </div>
		<div class="personContWrap">
			<router-view></router-view>
		</div>
    </div>
</template>

<script>
import common from '../../components/common.js'
export default {
    data() {
        return {
            allSec:0,  // 积累学时
            allScore:0,  // 积累学分
            curSec:0,  // 本年度学时
            curScore:0,  // 本年度学分
            name:'',  // 姓名
            mark:0,  // 收藏
			navList:[
				{
					name:'我的课程',
					url:'/personalCenter/myCourse'
				},
				{
					name:'我的收藏',
					url:'/personalCenter/myCollection'
				},{
					name:'学习统计',
					url:'/personalCenter/learnCount'
				},
			]
        }
    },
    mounted(){
        let timestamp = Date.parse(new Date())/1000;
        let data = {
            "TimeStamp":timestamp
        }
		this.getInfo(data);
        this.getMyScores(data);
		// 移除收藏时，改变收藏数
		common.$on('markVideoNum',(num)=>{this.mark = num;});
    },
    methods: {
        // 获取课时统计
        getMyScores(data){
            this.$axios.post(Const_Api_Root+'api/Member/MyScores',data,{
                contentType: 'application/json',
                dateType:'JSON',
                xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
            }).then((res)=>{
                // 错误提示
                if(res.data.Status == 0){
                    this.allSec = res.data.Data.AllSec;
                    this.allScore = res.data.Data.AllScore;
                    this.curSec = res.data.Data.CurSec;
                    this.curScore = res.data.Data.CurScore;
                }else if(res.data.Status != -2){
                    this.$message({
                        message: res.data.Data,
                        type: 'error',
                        duration: 3000
                    });
                }
            }).catch((err)=>{
                throw err;
            });
        },
		// 获取姓名
		getInfo(data){
			this.$axios.post(Const_Api_Root+'api/Member/Info',data,{
				contentType: 'application/json',
				dateType:'JSON',
				xHrFields: {withCredentials:true},
				beforeSend: function (XHR) {
					XHR.withCredentials = true;  // 跨域cookie支持代码
				}
			}).then((res)=>{
				// 错误提示
				if(res.data.Status == 0){
					this.name = res.data.Data.Name;
					this.mark = res.data.Data.MarkNum;
				}else if(res.data.Status != -2){
					this.$message({
						message: res.data.Data,
						type: 'error',
						duration: 3000
					});
				}
			}).catch((err)=>{
				throw err;
			});
		}
    },
    filters: {
        // 格式化名字
        formatName:(val)=>{
            if(val == ''){
                return val;
            }
            if(val.length == 4){
                val = val.substring(2);
            }else if(val.length == 2){
                val = val.substring(0);
            }else{
                val = val.substring(1);
            }
            return val;
        },
        // 格式化时间
        formatData:(value) => {
            let result = parseInt(value)
            let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
            let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
            let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));
            value = h+':'+m+':'+s;
            return value;
        }
    },
}
</script>

<style scoped lang="less">
@media screen and (min-width: 320px) and (max-width: 1024px) {
    .top_center,.center_nav{
        width: 100%;
    }
    .personalCenter{
        padding: 0 17px;
        box-sizing: border-box;
    }
    .top_center{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        border-bottom: 2px solid #fafafa;
        .infoBox{
            .xf{
                display: none;
            }
            .totalTime{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
                margin-top: 7px;
            }
        }
        .mobile_xf{
            background: #0061FE;
            border-radius: 16px 0 16px 0;
            color: #fff;
            padding: 8px 10px;
            box-sizing: border-box;

            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            span{
                display: block;
                text-align: center;
            }
            span:first-child{
                font-size: 20px;
            }
            span:last-child{
                font-size: 10px;
                color: rgba(255,255,255,0.81);
            }
        }
        .personWrap{
            margin-top: 30px;
            position: relative;
        }
        h4{
            font-size: 20px;
        }
    }
    // 头像
    .uploadBox{
        margin-right: 10px;
        p{
            width: 80px;
            height: 80px;
            font-size: 24px;
            line-height: 80px;
        }
    }
    // 导航
    .center_nav{
        margin: 30px auto 0;
        a{
            color: #19191a;
            margin-right: 50px;
        }
        .router-link-active{
            color: #0061fe;
        }
    }
    // 时长
    .dataWrap{
        display: flex;
        align-items: center;
        margin: 40px 0 30px;
        .sxsBox{
            width: 120px;
            p{
                font-size: 12px;
                color: rgba(25,25,26,0.80);
                margin-top: 5px;
            }
            h4{
                font-size: 16px;
            }
            h4,p{
                text-align: center;
            }
        }
    }
}
@media screen and (min-width: 1445px) {
    .mobile_xf{
        display: none;
    }
	.personContWrap{
		min-height: 800px;
	}
    .personalCenter{
        .personalInfoBox{
            background: url('../../assets/img/personal_bg.png') no-repeat;
            background-size: 100% 100%;
            height: 320px;
        }
        .top_center,.center_nav{
            width: 1200px;
        }
    }
    // 标题部分
    .top_center{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        h4{
            color: #FFFFFF;
            font-size: 24px;
        }
		.xf{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
    }
    .personWrap,.dataWrap{
        margin-top: 100px;
    }
    // 总时长
    .infoBox .totalTime{
        font-size: 14px;
        color: rgba(255,255,255,0.40);
    }
    // 头像
    .uploadBox{
        margin-right: 20px;
        p{
           width: 120px;
           height: 120px;
           font-size: 34px;
           line-height: 120px;
       }
    }
    // 导航
    .center_nav{
        margin: 59px auto 0;
        a{
            color: rgba(255,255,255,0.40);
            margin-right: 70px;
        }
        .router-link-active{
            color: #FFFFFF;
        }
    }
    // 时长
    .dataWrap{
        display: flex;
        align-items: center;
        .sxsBox{
            width: 200px;
            position: relative;
            p{
                font-size: 14px;
                color: rgba(255,255,255,0.40);
                margin-top: 15px;
            }
            h4,p{
                text-align: center;
            }
            span{
                display: block;
                background: rgba(255,255,255,0.10);
                border-radius: 1px;
                height: 30px;
                width: 2px;

                position: absolute;
                right: 0;
                top: 18px;
            }
        }
    }
}
@media screen and (min-width: 1029px) and (max-width: 1440px) {
    .mobile_xf{
        display: none;
    }
	.personContWrap{
		min-height: 600px;
	}
    .personalCenter{
        .personalInfoBox{
            background: url('../../assets/img/personal_bg.png') no-repeat;
            background-size: 100% 100%;
            height: 320px;
        }
        .top_center,.center_nav{
            width: 1100px;
        }
    }
    // 标题部分
    .top_center{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0 auto;
        h4{
            color: #FFFFFF;
            font-size: 24px;
        }
		.xf{
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
    }
    .personWrap,.dataWrap{
        margin-top: 100px;
    }
    // 总时长
    .infoBox .totalTime{
        font-size: 14px;
        color: rgba(255,255,255,0.40);
    }
    // 头像
    .uploadBox{
        margin-right: 20px;
        p{
           width: 120px;
           height: 120px;
           font-size: 34px;
           line-height: 120px;
       }
    }
    // 导航
    .center_nav{
        margin: 59px auto 0;
        a{
            color: rgba(255,255,255,0.40);
            margin-right: 70px;
        }
        .router-link-active{
            color: #FFFFFF;
        }
    }
    // 时长
    .dataWrap{
        display: flex;
        align-items: center;
        .sxsBox{
            width: 200px;
            position: relative;
            p{
                font-size: 14px;
                color: rgba(255,255,255,0.40);
                margin-top: 15px;
            }
            h4,p{
                text-align: center;
            }
            span{
                display: block;
                background: rgba(255,255,255,0.10);
                border-radius: 1px;
                height: 30px;
                width: 2px;

                position: absolute;
                right: 0;
                top: 18px;
            }
        }
    }
}
// 公用
.personalCenter,.personalInfoBox{
    width: 100%;
}
.top_center{
    .personWrap{
        display: flex;
        align-items: center;
    }
    .uploadBox{
        p{
            background: #0061FE;
            border-radius: 50%;
            color: #FFFFFF;
            text-align: center;
        }
    }
    .infoBox{
        .xf{
            background: rgba(255,255,255,0.10);
            border-radius: 16px 0 16px 0;
            color: #fff;
            width: 73px;
            height: 60px;
            margin: 7px 0 10px;
            span:first-child{
                font-size: 24px;
            }
            span:last-child{
                font-size: 12px;
                color: rgba(255,255,255,0.81);
            }
        }
    }
}
.center_nav{
    display: flex;
    align-items: center;
    a{
        display: block;
        height: 36px;
        font-size: 14px;
		
		position: relative;
    }
	.line{
		display: none;
		width: 50px;
		height: 4px;
		border-radius: 2px;
		background-color: #0061FE;
		
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}
    .router-link-active{
        .line{
			display: block;
		}
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenter/PersonalIndex.vue